export const STATE_MENU: string = "State_Menu";
export const STATE_DOLL: string = "State_Doll";
export const STATE_DRESS: string = "State_Dress";
export const STATE_HIEROGLYPH: string = "State_Hieroglyph";
export const STATE_MASK: string = "State_Mask";
export const STATE_PINATA: string = "State_Pinata";
export const STATE_QUILT: string = "State_Quilt";
export const STATE_PUPPET: string = "State_Puppet";

export const LOAD_SPLASH: string = "Load_Splash";
export const LOAD_INTERSTITIAL: string = "Load_Interstitial";

export const SPRITESHEET_UI: string = "ui";
export const SPRITESHEET_MENU: string = "menu";
export const SPRITESHEET_QUILT_PREFIX: string = "quilt-";
export const SPRITESHEET_DOLL_PREFIX: string = "doll-";
export const SPRITESHEET_DRESS_PREFIX: string = "dress-";
export const SPRITESHEET_MASK_PREFIX: string = "mask-";
export const SPRITESHEET_PINATA_PREFIX: string = "pinata-";
export const SPRITESHEET_HIERO_PREFIX: string = "hieroglyph-";
export const SPRITESHEET_PUPPET_PREFIX: string = "puppet-";
export const SPRITESHEET_DOOR_SEQUENCE: string = "door-sequence";

export const FONT_LUNA: string = "luna";
export const FONT_GEL_MED_35: string = "gelPenMedium35";

export const TWEEN_ONCOMPLETE: string = "onComplete";
export const TWEEN_ONUPDATE: string = "onUpdate";

export const DEBUG_MINIMAL_AUDIO: boolean = false;
export const DEBUG_SKIP_LOAD: boolean = false;
export const DEBUG_DEFAULT_STATE: string | undefined = undefined;
export const DEBUG_SKIP_ONBOARDING: boolean = false;
export const DEBUG_FAST_ONBOARDING: boolean = false;
